/* Info component on the LatestScript Component */
import React from 'react';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import styles from "../../../styles/Scene.module.css";

const InfoLatestScript = () => {
  return (
    <div>
      <Row className="mb-3">
        <Col md={{span: 8, offset: 2}}>
        <div className={`text-center px-3 pb-2 ${styles.SubTitle6 }`}>  
          <p className={`${styles.Red} text-center`}>INFO</p>
          <hr className={`mt-2 mb-0`}/>
        <p><span className={`${styles.Red}`}>*</span> Upload the latest script here. Only PDF files will be accepted. </p>
        <p className="pt-2"><span className={`${styles.Red}`}>*</span> Individual Scene Scripts can be uploaded on 
          each Scene page but the entire project script is added here.</p>
        <p className="pt-2"><span className={`${styles.Red}`}>*</span> If required add Script change details and notes in their fields.
        </p>
        <hr className={`mt-2 mb-0`}/>
         </div> 
        </Col>
      </Row>
    </div>
  )
}

export default InfoLatestScript